import { api } from '@/lib/api';
import type { Order, OrderStatus, OrderIntent, PlaceOrderInput } from './types';

// ---- Owner ----
export async function place_order(input: PlaceOrderInput): Promise<Order> {
  const res = await api.post<Order>('/user/orders', input);
  return res.data;
}

export async function fetch_my_orders(): Promise<Order[]> {
  const res = await api.get<Order[]>('/user/orders');
  return res.data;
}

export async function cancel_my_order(id: string, reason?: string): Promise<Order> {
  const res = await api.post<Order>(`/user/orders/${id}/cancel`, reason ? { reason } : {});
  return res.data;
}

// ---- Vendor ----
export async function fetch_vendor_orders(status?: OrderStatus): Promise<Order[]> {
  const res = await api.get<Order[]>('/vendor/orders', { params: status ? { status } : {} });
  return res.data;
}

export async function transition_order(id: string, intent: OrderIntent, reason?: string): Promise<Order> {
  const res = await api.post<Order>(`/vendor/orders/${id}/${intent}`, reason ? { reason } : {});
  return res.data;
}
